import { initialTradingViewSlice } from 'src/store/shared/trading-view/factory';
import type { TradingViewState } from 'src/store/shared/trading-view/types';
import { actionEsOnMessage } from '@skynet/data-ws-es';
import { listen } from 'src/store/trading/apiKeys/actions';
import { startAppListening } from 'src/store/middleware/listenerMiddleware';
import { routerHistoryChange } from 'src/store/router/actions';
import { skyRouter } from 'src/routes/sky-router';
import { selectTargetAccount } from 'src/store/trading/apiKeys/selectors';
import { ApplicationDomain } from 'src/routes/types';
import { ES_BOOTSTRAP_LISTEN_SECTION } from 'src/store/trading/listen-sections';

export const initialState: TradingViewState = {
  data: [],
  status: null,
  error: null,
};

const { actions, reducer } = initialTradingViewSlice({
  prefix: 'trading',
  initialState,
  messages: actionEsOnMessage,
  extraReducers: (builder) => {
    builder.addCase(listen, (state, action) => {
      const { section, ticker } = action.payload;
      if (section === ES_BOOTSTRAP_LISTEN_SECTION && ticker) {
        state.status = 'pending';
      }
    });
  },
});

startAppListening({
  actionCreator: routerHistoryChange,
  effect: (action, listenerApi) => {
    const state = listenerApi.getState();
    const entityId = skyRouter.getEntityId() ?? '';
    const section = skyRouter.getSection();
    const domain = skyRouter.getDomain();
    const currentAccount = selectTargetAccount(state);

    if (domain !== ApplicationDomain.Trading || !section || !entityId) {
      return;
    }

    if (typeof currentAccount !== 'string' || entityId !== currentAccount) {
      listenerApi.dispatch(actions.resetState());
    }
  },
});

export const trading = { actions, listen };

export default reducer;
